import { Box, styled } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';

export const Container = styled(Box)({
  width: '100%',
  height: '100%',
  backgroundColor: '#eef0f2',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  padding: 20,
  paddingBottom: 0
});

export const Wrapper = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'auto',
  gap: 12
});

export const Warning = styled(Box)({
  width: '100%',
  borderRadius: 120,
  padding: '12px 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  boxShadow: '0px 2px 4px 0px #30363C29',
  background: '#FED2D2'
});

export const WarningContent = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8
});

export const WarningIconBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#FA2020',
  borderRadius: '50%',
  padding: 4
});

export const WarningButton = styled(SButton)({
  color: '#fff',
  background: '#FA2020',
  borderRadius: 120,
  minHeight: 35,

  '&:hover': {
    background: '#FA2020'
  }
});
